import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import Provider from 'react-redux/es/components/Provider';
import createBrowserHistory from 'history/createBrowserHistory';

import BrowserProvider from 'jsx/layout/BrowserProvider';
import UserManager from 'jsx/auth/UserManager';
import AuthProvider from 'jsx/auth/AuthProvider';
import ProductProvider from 'jsx/auth/ProductProvider';
import ScrollToTop from 'jsx/layout/ScrollToTop';
import { addLocale } from 'jsx/locale/ducks';
import { translationApi } from 'utils/api/shared';

import './polyfills';
import './main.less';
import App from './App';
import configureStore from './store';
import 'json.date-extensions/json.date-extensions.js';



export const store = configureStore();
const history = createBrowserHistory();
export const userManager = new UserManager({
  authUrl: process.env.REACT_APP_STS_URL,
  clientId: 'Innheimtukerfi',
  responseType: 'id_token code',
  redirectUri: `${window.location.protocol}//${window.location.host}/_cb`,
  logoutUri: `${window.location.protocol}//${window.location.host}/_out`,
  scope: 'profile openid offline_access sharedapi creditinfo collectionsystemapi',
  secret: 'CollectionSystemClientClientAccessKey2017',
  postLogoutRedirectUri: `${window.location.protocol}//${window.location.host}`,
  roles: ['3001']
});




render(
  <Provider store={store}>
    <Router history={history}>
      <ScrollToTop>
        <AuthProvider userManager={userManager}>
          <ProductProvider>
            <BrowserProvider />
            <App />
          </ProductProvider>
        </AuthProvider>
      </ScrollToTop>
    </Router>
  </Provider>,
  document.getElementById('root')
);


translationApi.getTranslationsIS(0).then(t => store.dispatch(addLocale('is', t)));
translationApi.getTranslationsEN(0).then(t => store.dispatch(addLocale('en', t)));




// WEBPACK FOOTER //
// ./src/index.js